<form [formGroup]="form">
  <label>{{ 'MAP-DISPLAY.SELECT-WIDGETS' | translate }}</label>
  <div class="widget-toggle-container">
    @for (widget of widgetOptions; track widget.id) {
      <div
        class="widget-toggle"
        [class.disabled]="form.get(widget.id).disabled">
        <i [class]="'icon ' + widget.icon"></i>
        <span>{{ widget.name | translate }}</span>
        @if (state.configuration()[widget.id] && widget.showConfigForm; as canConfigure) {
          <i
            class="widget-settings icon icon-configure_settings"
            (click)="widget.showConfigForm()"></i>
        }
        <topo-switch [formControlName]="widget.id" />
      </div>
    }
  </div>
</form>
